import React from 'react';
import { ClientFeature } from '@frontend/app/constants';
import { useClientFeatures } from '@frontend/context/ClientFeatureContext';
import { CampaignProvider } from './CampaignContext';
import { NewCampaignSetup } from './NewCampaignSetup';
import { CampaignForm } from './CampaignForm';

export const CampaignPage: React.FC = () => {
  const { [ClientFeature.FLEXIBLE_PROJECT]: isFlexibleProjectEnabled } = useClientFeatures();

  return (
    <CampaignProvider>
      {isFlexibleProjectEnabled ? <NewCampaignSetup /> : <CampaignForm />}
    </CampaignProvider>
  );
};
